import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '@babel/runtime-corejs3/core-js-stable/instance/fill';
import IcInputDelete from '../icons/IcInputDelete.js';
import { INPUT_AREA_TEXT_ALIGN, INPUT_BOX_SIZE } from '../../constants/input.js';
import styles from './InputArea.module.scss.js';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
function InputArea(_ref) {
  var type = _ref.type,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? INPUT_AREA_TEXT_ALIGN.LEFT : _ref$textAlign,
    space = _ref.space,
    _ref$boxSize = _ref.boxSize,
    boxSize = _ref$boxSize === void 0 ? INPUT_BOX_SIZE.LARGE : _ref$boxSize,
    isFocused = _ref.isFocused,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    errorMessage = _ref.errorMessage,
    guideMessage = _ref.guideMessage,
    _ref$isShowTextCount = _ref.isShowTextCount,
    isShowTextCount = _ref$isShowTextCount === void 0 ? false : _ref$isShowTextCount,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    maxLength = _ref.maxLength,
    children = _ref.children;
  var isShowMessageSection = hasError && !!errorMessage || !!guideMessage || isShowTextCount && !!maxLength;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: cx('area-input', "type-".concat(type), _defineProperty(_defineProperty(_defineProperty({
      'is-focused': isFocused,
      'has-error': hasError,
      'is-disabled': disabled
    }, "align-".concat(textAlign), textAlign), "space".concat(space), space), "size-".concat(boxSize), boxSize))
  }, children), isShowMessageSection && ( /*#__PURE__*/React.createElement("div", {
    className: cx('area-message')
  }, hasError && !!errorMessage ? /*#__PURE__*/React.createElement("p", {
    className: cx('error-message')
  }, errorMessage) : guideMessage, isShowTextCount && ( /*#__PURE__*/React.createElement("span", {
    className: cx('text-count')
  }, /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uC785\uB825\uD55C \uAE00\uC790\uC218"), value.length, "/", /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uCD1D \uAE00\uC790\uC218"), maxLength)))));
}
function SideComponent(_ref2) {
  var children = _ref2.children,
    type = _ref2.type;
  return /*#__PURE__*/React.createElement("span", {
    className: cx('side', _defineProperty({}, "type-".concat(type), type))
  }, children);
}
function DeleteButton(_ref3) {
  var isShow = _ref3.isShow,
    onClick = _ref3.onClick;
  if (!isShow) {
    return null;
  }
  var handleMouseDown = function handleMouseDown(e) {
    e.preventDefault();
  };
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button-delete'),
    onMouseDown: handleMouseDown,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(IcInputDelete, {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uC785\uB825\uB0B4\uC6A9 \uC0AD\uC81C"));
}
function Dash(_ref4) {
  var space = _ref4.space;
  return /*#__PURE__*/React.createElement("span", {
    className: cx('dash', _defineProperty({}, "space".concat(space), space))
  }, /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "-"));
}
var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    className: cx('input-value')
  }, /*#__PURE__*/React.createElement("input", _objectSpread({
    className: cx('value'),
    ref: ref
  }, props)));
});
function InputMasking(_ref5) {
  var _context;
  var maskingStartIndex = _ref5.maskingStartIndex,
    _ref5$value = _ref5.value,
    value = _ref5$value === void 0 ? '' : _ref5$value,
    _ref5$placeholder = _ref5.placeholder,
    placeholder = _ref5$placeholder === void 0 ? '' : _ref5$placeholder,
    onClick = _ref5.onClick,
    onFocus = _ref5.onFocus,
    onBlur = _ref5.onBlur;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('masking-value')
  }, /*#__PURE__*/React.createElement("input", {
    className: cx('value', {
      'masking-hidden': true
    }),
    value: value,
    placeholder: placeholder,
    readOnly: true,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('masking-text'),
    "aria-hidden": true
  }, _mapInstanceProperty(_context = value.split('')).call(_context, function (valueChar, index) {
    if (index >= maskingStartIndex) {
      return /*#__PURE__*/React.createElement("span", {
        key: index,
        className: cx('dot')
      }, /*#__PURE__*/React.createElement("span", {
        className: "blind"
      }, index + 1, "\uBC88\uC9F8 \uC790\uB9AC \uC785\uB825"));
    }
    return /*#__PURE__*/React.createElement("span", {
      key: index,
      className: cx('number')
    }, valueChar);
  })));
}
InputArea.Dash = Dash;
InputArea.Input = Input;
InputArea.InputMasking = InputMasking;
InputArea.DeleteButton = DeleteButton;
InputArea.SideComponent = SideComponent;

export { InputArea as default };
